import { Directive, Input, TemplateRef, ViewContainerRef, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { FieldVisibilityService } from '../../services/field-visibility-service/field-visibility.service';

@Directive({
  selector: '[appHideField]'
})
export class HideFieldDirective implements OnDestroy {
  private hasView = false;
  private fieldName: string;
  private subscription: Subscription;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private fieldVisibilityService: FieldVisibilityService
  ) {
    this.subscription = this.fieldVisibilityService.getHiddenFieldsObservable().subscribe(() => {
      if (this.fieldName) {
        this.updateView();
      }
    });
  }

  @Input() set appHideField(fieldName: string) {
    this.fieldName = fieldName;
    this.updateView();
  }

  private updateView(): void {
    const shouldHide = this.fieldVisibilityService.isFieldHidden(this.fieldName);

    if (shouldHide && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    } else if (!shouldHide && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    }
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
